export default __webpack_public_path__ + "static/media/resources-img.22acb33d.jpeg";